// extracted by mini-css-extract-plugin
export default {"up":"ShowArrowButton_up__ZdxQ9"};